export default "__VITE_ASSET__Bv85EB9l__"